import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { MexusEntity } from '../../mexus-entity'

@Directive({
  selector: '[appEntitySelect]',
})
export class MexusEntitySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)
  private enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.placeholder = 'context.collection'
    this.select.displayProperty = 'displayValue'

    this.select.dataSource = this.enumTranslationService.enumDataSource(
      MexusEntity,
      'MexusEntity',
      false
    )
  }
}
